var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPessoa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.39995 7.4C9.16726 7.4 10.6 5.96731 10.6 4.2C10.6 2.43269 9.16726 1 7.39995 1C5.63264 1 4.19995 2.43269 4.19995 4.2C4.19995 5.96731 5.63264 7.4 7.39995 7.4Z",
    stroke: "#333333",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7984 13.8008C13.7995 13.6696 13.8 13.5362 13.8 13.4008C13.8 11.4128 10.9344 9.80078 7.4 9.80078C3.8656 9.80078 1 11.4128 1 13.4008C1 15.3888 1 17.0008 7.4 17.0008C9.1848 17.0008 10.472 16.8752 11.4 16.6512",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPessoa);
export default __webpack_public_path__ + "static/media/iconPessoa.8724c8b6e152e6342cf6aee8ac21fd96.svg";
export { ForwardRef as ReactComponent };